/*
  Stance Motorsport - specific model names for the Year / Make / Model side menus and the Vehicle Fitment chart
  (IS300, ES330, GS430, 328i, E320, 3.2TL ...). Added on top of window.PG_TRIMS in assets/pg-ymm-ui.js - never
  replaces an existing entry; both lists are read together. Format = PG_TRIMS: "Make|Model": "Name:fromYear-toYear, ..."
*/
window.PG_TRIMS_MORE = {
 "Lexus|IS": "IS300:2001-2005",
 "Lexus|ES": "ES250:1990-1991, ES300:1992-2003, ES330:2004-2006",
 "Lexus|GS": "GS300:1993-2005, GS400:1998-2000, GS430:2001-2005",
 "Lexus|LS": "LS400:1995-2000, LS430:2001-2006",
 "Lexus|LX": "LX450:1996-1997, LX470:1998-2007",
 "Lexus|RX": "RX300:1999-2003, RX330:2004-2006, RX400h:2006-2008, RX350:2007-2009",
 "Lexus|SC": "SC300:1992-2000, SC400:1992-2000, SC430:2002-2010",
 "Lexus|GX": "GX470:2003-2009",
 "Lexus|HS": "HS250h:2010-2012",
 "Lexus|LC": "LC500:2018-2026, LC500h:2018-2026",
 "Lexus|RZ": "RZ450e:2023-2025, RZ300e:2024-2026",
 "Lexus|TX": "TX350:2024-2026, TX500h:2024-2026, TX550h+:2025-2026",
 "Lexus|UX": "UX200:2019-2022, UX250h:2019-2024, UX300h:2025-2026",
 "BMW|3 Series": "320i:1977-1983, 318i:1984-1991, 325e:1984-1988, 325i:1987-1991, 325is:1987-1991, 325ix:1988-1991, M3:1988-1991",
 "BMW|5 Series": "530i:1975-1978, 528i:1979-1981, 528e:1982-1988, 533i:1983-1984, 535i:1985-1993, M5:1988-1993, 525i:1989-1995, 530i:1994-1995, 540i:1994-1995, 528i:1997-2000, 525i:2001-2003, 530i:2001-2003, 540i:1997-2003, M5:2000-2003, 530i:2024-2026, 540i:2024-2026, i5 eDrive40:2024-2026, i5 M60:2024-2026, M5:2025-2026",
 "BMW|6 Series": "633CSi:1977-1984, 635CSi:1985-1989, M6:1987-1988, 645Ci:2004-2005, 650i:2006-2019, M6:2006-2019, 640i:2012-2019, 640i Gran Coupe:2013-2019, 650i Gran Coupe:2013-2019",
 "BMW|7 Series": "733i:1978-1984, 735i:1985-1992, 750iL:1988-2001, 740i:1993-2001, 740iL:1993-2001, 745i:2002-2005, 745Li:2002-2005, 760Li:2003-2019, 750i:2006-2026, 750Li:2006-2019, 740i:2009-2026, 740Li:2009-2019, 745e:2020-2022, M760i:2020-2022, 760i xDrive:2023-2026, i7:2023-2026",
 "BMW|8 Series": "850i:1991-1994, 840Ci:1994-1997, 850Ci:1994-1997, 850CSi:1994-1997, 840i:2019-2026, M850i:2019-2026, M8:2020-2026",
 "BMW|X1": "xDrive28i:2013-2026, sDrive28i:2013-2022, M35i:2025-2026",
 "BMW|X2": "sDrive28i:2018-2023, xDrive28i:2018-2026, M35i:2019-2026",
 "BMW|X3": "2.5i:2004-2006, 3.0i:2004-2006, 3.0si:2007-2010, xDrive30i:2007-2010, 30 xDrive:2025-2026, M50:2025-2026",
 "BMW|X4": "xDrive28i:2015-2018, xDrive35i:2015-2018, M40i:2016-2025, xDrive30i:2019-2025, X4 M:2020-2025",
 "BMW|X5": "3.0i:2001-2006, 4.4i:2000-2006, 4.6is:2002-2003, 4.8is:2004-2006",
 "BMW|X6": "xDrive35i:2008-2019, xDrive50i:2008-2019, X6 M:2010-2026, sDrive40i:2020-2026, xDrive40i:2020-2026, M50i:2020-2023, M60i:2024-2026",
 "BMW|X7": "xDrive40i:2019-2026, M50i:2020-2022, M60i:2023-2026, Alpina XB7:2021-2026",
 "BMW|Z3": "1.9:1996-1998, 2.8:1997-2000, 2.3:1999-2000, 2.5i:2001-2002, 3.0i:2001-2002, M Roadster:1998-2002, M Coupe:1999-2002",
 "BMW|2 Series": "228i Gran Coupe:2022-2026, M235i Gran Coupe:2022-2026",
 "BMW|3 Series Gran Turismo": "328i GT:2014-2016, 335i GT:2014-2016, 330i GT:2017-2019, 340i GT:2017-2019",
 "BMW|5 Series Gran Turismo": "535i GT:2010-2017, 550i GT:2010-2017",
 "Mercedes-Benz|C-Class": "C220:1994-1996, C280:1994-2000, C36 AMG:1995-1997, C230:1997-2000, C43 AMG:1998-2000, C240:2001-2005, C320:2001-2005, C32 AMG:2002-2004, C230:2003-2007, C55 AMG:2005-2006, C280:2006-2007, C350:2006-2007",
 "Mercedes-Benz|E-Class": "E320:1994-2009, E420:1994-1995, E500:1994-1995, E300 Diesel:1995-1999, E430:1998-2002, E55 AMG:1999-2006, E500:2003-2006, E350:2006-2009, E550:2007-2009, E63 AMG:2007-2009",
 "Mercedes-Benz|S-Class": "450SE:1973-1980, 380SEL:1981-1985, 500SEL:1981-1991, 420SEL:1986-1991, 560SEL:1986-1991, 300SE:1988-1991, 300SD:1992-1993, 400SEL:1992-1993, 500SEL:1992-1993, 600SEL:1992-1993, S320:1994-1999, S420:1994-1999, S500:1994-2006, S600:1994-2013, S430:2000-2006, S55 AMG:2001-2006, S65 AMG:2004-2013, S550:2007-2013, S63 AMG:2008-2013, S400 Hybrid:2010-2013",
 "Mercedes-Benz|M-Class": "ML320:1998-2003, ML430:1999-2001, ML55 AMG:2000-2003, ML500:2002-2007, ML350:2003-2015, ML63 AMG:2007-2015, ML550:2008-2011, ML320 CDI:2007-2009, ML250 BlueTEC:2015-2015, ML400:2015-2015",
 "Mercedes-Benz|CL-Class": "CL500:1998-2006, CL600:1998-2014, CL55 AMG:2001-2006, CL65 AMG:2005-2014, CL550:2007-2014, CL63 AMG:2008-2014",
 "Mercedes-Benz|CLS-Class": "CLS500:2006-2006, CLS55 AMG:2006-2006, CLS550:2007-2011, CLS63 AMG:2007-2011, CLS450:2019-2023, AMG CLS53:2019-2023",
 "Mercedes-Benz|SL-Class": "190SL:1955-1963, 300SL:1955-1963, 230SL:1963-1967, 250SL:1967-1968, 280SL:1968-1971, 350SL:1972-1972, 450SL:1973-1980, 380SL:1981-1985, 560SL:1986-1989, 300SL:1990-1993, 500SL:1990-1998, SL320:1994-1997, SL500:1994-2012, SL600:1994-2014, SL55 AMG:2003-2008, SL65 AMG:2005-2019, SL550:2007-2020, SL63 AMG:2009-2015, SL450:2017-2020, AMG SL 55:2022-2026, AMG SL 63:2022-2026, AMG SL 43:2023-2026",
 "Mercedes-Benz|SLC-Class": "350SLC:1972-1972, 450SLC:1973-1980, 380SLC:1981-1981, SLC300:2017-2020, AMG SLC43:2017-2020",
 "Mercedes-Benz|SLK-Class": "SLK230:1998-2004, SLK320:2001-2004, SLK32 AMG:2002-2004",
 "Mercedes-Benz|R-Class": "R350:2006-2012, R500:2006-2007, R63 AMG:2007-2007, R320 CDI:2007-2009",
 "Mercedes-Benz|GLB-Class": "GLB250:2020-2026, AMG GLB35:2021-2026",
 "Mercedes-Benz|CLE-Class": "CLE300:2024-2026, CLE450:2024-2026, AMG CLE53:2024-2026",
 "Mercedes-Benz|190 Series": "190E:1984-1993, 190D:1984-1989",
 "Mercedes-Benz|EQB": "EQB250+:2022-2025, EQB300:2022-2025, EQB350:2022-2025",
 "Mercedes-Benz|EQE Sedan": "EQE350+:2023-2026, EQE500:2023-2026, AMG EQE:2023-2026",
 "Mercedes-Benz|EQE SUV": "EQE350+:2023-2026, EQE500:2023-2026, AMG EQE:2023-2026",
 "Mercedes-Benz|EQS Sedan": "EQS450+:2022-2026, EQS580:2022-2026, AMG EQS:2022-2026",
 "Mercedes-Benz|EQS SUV": "EQS450+:2023-2026, EQS580:2023-2026",
 "Mercedes-Benz|AMG GT": "GT:2016-2026, GT S:2016-2021, GT C:2017-2021, GT R:2017-2021, GT 55:2024-2026, GT 63:2024-2026",
 "Mercedes-Benz|G-Class": "G500:2002-2008, G55 AMG:2003-2011, G550:2009-2026, G63 AMG:2013-2026, G65 AMG:2013-2018",
 "Mercedes-Benz|Sprinter": "1500:2010-2026, 2500:2010-2026, 3500:2010-2026",
 "Acura|CL": "2.2CL:1997-1997, 2.3CL:1998-1999, 3.0CL:1997-1999, 3.2CL:2001-2003, 3.2CL Type-S:2001-2003",
 "Acura|TL": "2.5TL:1996-1998, 3.2TL:1996-2003, 3.2TL Type-S:2002-2003",
 "Acura|RL": "3.5RL:1996-2004, RL:2005-2012",
 "Acura|Legend": "Sedan:1986-1995, Coupe:1987-1995",
 "Acura|Integra": "RS:1986-1993, LS:1986-1993, SE:1987-1989, GS:1990-1993, GS-R:1992-1993",
 "Acura|Vigor": "LS:1992-1994, GS:1992-1994",
 "Acura|NSX": "NSX:1991-2005, NSX-T:1995-2005, NSX:2017-2021, Type S:2022-2022",
 "Acura|MDX": "Base:2001-2006, Touring:2001-2006",
 "Acura|RLX": "Base:2014-2020, Sport Hybrid:2014-2020",
 "Toyota|Tacoma": "Base:1995-2015, PreRunner:1998-2015, SR5:1995-2023, TRD Sport:2005-2026, TRD Off-Road:2005-2026, X-Runner:2005-2013, SR:2016-2026, Limited:2016-2026, TRD Pro:2015-2026",
 "Nissan|GT-R": "Premium:2009-2024, Black Edition:2009-2016, Track Edition:2015-2021, NISMO:2015-2024",
 "Nissan|300ZX": "Base:1984-1996, Turbo:1984-1996, 2+2:1984-1996, Convertible:1993-1996",
 "Nissan|240SX": "Base:1989-1998, SE:1989-1998, LE:1989-1998",
 "Hyundai|Elantra": "SE:2021-2026, SEL:2021-2026, Limited:2021-2026, N Line:2021-2026, Elantra N:2022-2026",
 "Hyundai|Sonata": "SE:2020-2026, SEL:2020-2026, SEL Plus:2020-2023, Limited:2020-2026, N Line:2021-2026"
};

/* Smallest wheel diameter each submodel can run (factory minimum / brake clearance), where it is larger than the
   rest of that model line - e.g. a 3 Series 330i runs 17", an M340i needs 18". "Make|Model": "Submodel:inches, ..." */
window.PG_TRIM_MIN = {
 "BMW|3 Series (G20/G21)": "M340i:18",
 "BMW|3 Series (F30/F31/F34)": "335i:18, 340i:18",
 "BMW|3 Series (E90/E92/E93)": "335i:17, 335xi / 335i xDrive:17, 335d:17, 335is:18",
 "BMW|4 Series (F32/F33/F36)": "435i:18, 440i:18",
 "BMW|2 Series (F22/F23)": "M235i:18, M240i:18",
 "BMW|5 Series (F10/F11)": "535i:18, 550i:18, 535d:18",
 "BMW|Z4 (E89)": "sDrive35i:18, sDrive35is:18",
 "Lexus|IS (2IS)": "IS350:18",
 "Lexus|IS (3IS)": "IS350:18",
 "Lexus|IS (4IS)": "IS500 F Sport Performance:19",
 "Lexus|GS": "GS430:18, GS460:18, GS450h:18, GS F:19",
 "Lexus|RC": "RC F:19",
 "Mercedes-Benz|C-Class (W204)": "C63 AMG:18",
 "Mercedes-Benz|C-Class (W205)": "C43 AMG:18, C63 AMG:18, C63 S AMG:19",
 "Mercedes-Benz|C-Class (W206)": "C43 AMG:19, C63 S E Performance:19",
 "Mercedes-Benz|E-Class (W212)": "E63 AMG:18",
 "Mercedes-Benz|E-Class (W213)": "E53 AMG:19, E63 AMG:19, E63 S AMG:19",
 "Ford|Mustang": "Bullitt:19, Mach 1:19, Shelby GT350:19, Shelby GT500:18, Shelby GT500 (S550):20, Dark Horse:19",
 "Dodge|Challenger": "R/T Scat Pack:20, SRT 392:20, SRT Hellcat:20, SRT Hellcat Redeye:20, SRT Demon:18",
 "Dodge|Charger": "Scat Pack:20, SRT 392:20, SRT Hellcat:20, SRT Hellcat Redeye:20",
 "Chevrolet|Camaro": "SS:20, ZL1:20, Z/28:19",
 "Nissan|370Z": "Sport:19, NISMO:19",
 "Tesla|Model 3": "Performance:20",
 "Tesla|Model Y": "Performance:21",
 "Toyota|GR Supra": "3.0 Premium:19, A91 Edition:19",
 "Infiniti|Q50": "Red Sport 400:19",
 "Infiniti|Q60": "Red Sport 400:19",
 "Kia|Stinger": "GT:19, GT1:19, GT2:19",
 "Genesis|G70": "3.3T:19",
 "Acura|Integra": "Type S:19",
 "Acura|TLX": "Type S:19"
};

(function () {
  function minDia(mk, md, trim) {
    if (!trim) return 0;
    var raw = (window.PG_TRIM_MIN || {})[mk + '|' + md]; if (!raw) return 0;
    var hit = 0;
    raw.split(',').forEach(function (p) { var m = p.trim().match(/^(.*):(\d+)$/); if (m && m[1].trim() === trim) hit = +m[2]; });
    return hit;
  }
  window.PG_TRIM_MINDIA = minDia;
  /* the submodel the customer picked (from the Year / Make / Model menus), remembered across pages */
  function load() { try { var t = JSON.parse(localStorage.getItem('pgTrim') || 'null'), v = JSON.parse(localStorage.getItem('pgVehicle') || 'null'); if (t && v && t.mk === v.mk && t.md === v.model) window.PG_CUR = t; else window.PG_CUR = null; } catch (e) {} }
  load();
  document.addEventListener('pg:vehicle', function (e) {
    var c = e.detail || {}; if (!c.make || !c.model) return;
    window.PG_CUR = { mk: c.make, md: c.model, trim: c.trim || '' };
    try { localStorage.setItem('pgTrim', JSON.stringify(window.PG_CUR)); } catch (er) {}
  });
  window.addEventListener('storage', load);
  /* every fit check (Size Guide, Shop by Vehicle, sidebar, product checker, fitment chart) respects the submodel:
     PG_FIT.axle(row, size, axle, patterns, submodel) - submodel '' = no submodel, omitted = the one the customer picked */
  function wrap() {
    var F = window.PG_FIT; if (!F || F._trim) return !!F;
    var ax = F.axle;
    F.axle = function (row, s, a, p, trim) {
      var r = ax.call(F, row, s, a, p); if (!r || !r.lvl || !row) return r;
      var t = trim !== undefined ? trim : (window.PG_CUR && window.PG_CUR.mk === row[0] && window.PG_CUR.md === row[1] ? window.PG_CUR.trim : '');
      var md = minDia(row[0], row[1], t);
      if (md && s && s.d < md) { r.lvl = 0; r.why = 'small'; r.trimMin = md; }
      return r;
    };
    F._trim = true; return true;
  }
  if (!wrap()) {
    /* Stance creates PG_FIT inside assets/pg-fit-c.js, sometimes after this file: wrap it the moment it is set */
    try {
      Object.defineProperty(window, 'PG_FIT', { configurable: true, enumerable: true, get: function () { return undefined; },
        set: function (v) { Object.defineProperty(window, 'PG_FIT', { value: v, writable: true, configurable: true, enumerable: true }); wrap(); } });
    } catch (e) {}
    document.addEventListener('DOMContentLoaded', wrap);
  }
  window.addEventListener('load', wrap);
  /* "Parts for your 2019 BMW 3 Series": no product count next to it */
  function headCount() {
    document.querySelectorAll('.pgx-headbar__t').forEach(function (t) {
      var h = t.querySelector('h2'), n = t.querySelector('.pgx-headbar__n'); if (!h || !n) return;
      n.style.display = /^\s*Parts for your/i.test(h.textContent) ? 'none' : '';
    });
  }
  var hq = false;
  new MutationObserver(function () { if (hq) return; hq = true; (window.requestAnimationFrame || setTimeout)(function () { hq = false; headCount(); }); })
    .observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
